import { Reducer } from "redux";
import { SingleResourceLoadingState } from "../../common/store/stateHelpers";

import { StatisticsModel, StatisticsFilter } from "../StatisticsModel";

export enum ActionType {
    RequestStatisticsData = "STATISTICS/REQUEST_STATISTICS_DATA",
    ReceivedStatisticsData = "STATISTICS/RECEIVED_STATISTICS_DATA",
}

export interface RequestStatisticsDataAction {
    type: ActionType.RequestStatisticsData;
    filters?: StatisticsFilter;
}

interface ReceivedStatisticsDataAction {
    type: ActionType.ReceivedStatisticsData;
    data: StatisticsModel;
}

export const actionCreators = {
    requestStatisticsData: (filters: StatisticsFilter) => <RequestStatisticsDataAction>{ type: ActionType.RequestStatisticsData, filters },
    receivedStatisticsData: (data: StatisticsModel) => <ReceivedStatisticsDataAction>{ type: ActionType.ReceivedStatisticsData, data },
}

export type StatisticsState = SingleResourceLoadingState<StatisticsModel>;

const initialState: StatisticsState = {
    isLoading: false,
    data: undefined,
}

export type StatisticsAction = RequestStatisticsDataAction | ReceivedStatisticsDataAction;

export const reducer: Reducer<StatisticsState> = (state: StatisticsState, action: StatisticsAction) => {
    switch (action.type) {
        case ActionType.RequestStatisticsData:
            return {
                ...state,
                isLoading: true,
                data: undefined
            }
        case ActionType.ReceivedStatisticsData:
            return {
                ...state,
                isLoading: false,
                data: action.data
            }
        default:
            const exhaustiveCheck: never = action;
    }

    return state || initialState;
}


// WEBPACK FOOTER //
// ./src/statistics/store/statisticsStore.ts